import React, { useContext, useEffect, useRef, useState } from 'react'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { AccordComponent, Line } from './EmployeeApplication'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {
  AccordionSummary,
  Box,
  Button,
  ButtonGroup,
  Chip,
  Menu,
  MenuItem,
} from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import BigModal from '../../../components/Modals/BigModal'
import ContentPasteIcon from '@mui/icons-material/ContentPaste'
import API from '../../../services/API'
import EditReferee from './EditReferee'
import SmallModal from '../../../components/Modals/SmallModal'
import { GlobalContext } from '../../../App'
import S3DocumentUploadDisplay from '../../../components/images/S3DocumentUploadDisplay'
import S3Document from '../../../components/images/S3Document'
import PDFViewer from '../../../components/Modals/PDFViewer'
import validator from 'validator'

const References = ({ application, getApplication }) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [selectedMenuReference, setSelectedMenuReference] = useState(null)
  const [referenceUrlToCopy, setReferenceUrlToCopy] = useState('')
  const [openEditReferee, setOpenEditReferee] = useState(false)
  const [openAddResponse, setOpenAddResponse] = useState(false)
  const [openReferencePDF, setOpenReferencePDF] = useState(false)

  const handleResendInvitation = () => {
    API.post('/employees/applications/reference-request', {
      reference1or2: selectedMenuReference,
      applicationID: application._id,
    }).then((res) => {
      if (res.status === 200) {
        getApplication()
        setMenuAnchorEl(null)
        setSelectedMenuReference(null)
      }
    })
  }
  const handleReferenceURL = () => {
    API.post('/employees/applications/reference-url', {
      applicationID: application._id,
      reference1or2: selectedMenuReference,
    })
      .then((res) => {
        if (res.status === 200) {
          setReferenceUrlToCopy(res.data)
          setMenuAnchorEl(null)
          setSelectedMenuReference(null)
        }
      })
      .catch((e) => console.log(e))
  }

  return (
    <AccordComponent title="References">
      <Grid item xs={12}>
        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="title3">Reference 1</Typography>
          {!application?.reference1?.response && (
            <Chip
              size="small"
              color="anMainBlue"
              label="Options"
              icon={<ArrowDropDownIcon />}
              onClick={(e) => {
                setMenuAnchorEl(e.currentTarget)
                setSelectedMenuReference(1)
              }}
              sx={{ borderRadius: 1, cursor: 'pointer' }}
            />
          )}
        </Stack>
      </Grid>
      <Line title="Name" value={application?.reference1?.fullName ?? ''} />
      <Line
        title="Relationship"
        value={application?.reference1?.relationship ?? ''}
      />
      <Line title="Company" value={application?.reference1?.company ?? ''} />
      <Line
        title="Position/Role"
        value={application?.reference1?.position ?? ''}
      />
      <Line title="Email" value={application?.reference1?.email ?? ''} />
      <Line title="Duration" value={application?.reference1?.duration ?? ''} />
      <Line
        title="Phone Number"
        value={application?.reference1?.phoneNumber ?? ''}
      />
      <Line title="Comments" value={application?.reference1?.comments ?? ''} />
      {Object.keys(application?.reference1?.response ?? []).length > 0 && (
        <Grid item xs={12}>
          {application?.reference1?.response?.document ? (
            <Button
              variant="outlined"
              color="anBlue"
              onClick={() => {
                setOpenReferencePDF(application.reference1.response.document)
                setMenuAnchorEl(null)
                setSelectedMenuReference(null)
              }}
            >
              View Reference
            </Button>
          ) : (
            <Accordion sx={{ border: 'solid 2px #268EBB' }}>
              <AccordionSummary>View Response</AccordionSummary>
              <AccordionDetails>
                {Object.keys(application?.reference1?.response)
                  .filter((x) => x !== 'document')
                  .map((i) => (
                    <Stack key={i}>
                      <Typography fontWeight={600} fontSize="0.7rem">
                        {i}
                      </Typography>
                      <Typography fontSize="0.7rem">
                        {application.reference1.response[i]}
                      </Typography>
                    </Stack>
                  ))}
              </AccordionDetails>
            </Accordion>
          )}
        </Grid>
      )}
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="title3">Reference 2</Typography>
          {!application?.reference2?.response && (
            <Chip
              size="small"
              color="anMainBlue"
              label="Options"
              icon={<ArrowDropDownIcon />}
              onClick={(e) => {
                setMenuAnchorEl(e.currentTarget)
                setSelectedMenuReference(2)
              }}
              sx={{ borderRadius: 1, cursor: 'pointer' }}
            />
          )}
        </Stack>
      </Grid>

      <Line title="Name" value={application?.reference2?.fullName ?? ''} />
      <Line
        title="Relationship"
        value={application?.reference2?.relationship ?? ''}
      />
      <Line title="Company" value={application?.reference2?.company ?? ''} />
      <Line
        title="Position/Role"
        value={application?.reference2?.position ?? ''}
      />
      <Line title="Email" value={application?.reference2?.email ?? ''} />
      <Line title="Duration" value={application?.reference2?.duration ?? ''} />
      <Line
        title="Phone Number"
        value={application?.reference2?.phoneNumber ?? ''}
      />
      <Line title="Comments" value={application?.reference2?.comments ?? ''} />
      {Object.keys(application?.reference2?.response ?? []).length > 0 && (
        <Grid item xs={12}>
          {application?.reference2?.response?.document ? (
            <Button
              variant="outlined"
              color="anBlue"
              onClick={() => {
                API.post('/gets3downloadurl', {
                  key: application.reference2.response.document,
                }).then((res) => {
                  setOpenReferencePDF(application.reference2.response.document)
                  setMenuAnchorEl(null)
                  setSelectedMenuReference(null)
                })
              }}
            >
              View Reference
            </Button>
          ) : (
            <Accordion sx={{ border: 'solid 2px #268EBB' }}>
              <AccordionSummary>View Response</AccordionSummary>
              <AccordionDetails>
                {Object.keys(application?.reference2?.response)
                  .filter((x) => x !== 'document')
                  .map((i) => (
                    <Stack key={i}>
                      <Typography fontWeight={600} fontSize="0.7rem">
                        {i}
                      </Typography>
                      <Typography fontSize="0.7rem">
                        {application.reference2.response[i]}
                      </Typography>
                    </Stack>
                  ))}
              </AccordionDetails>
            </Accordion>
          )}
        </Grid>
      )}
      <PDFViewer
        open={!!openReferencePDF}
        onClose={() => setOpenReferencePDF(null)}
        s3key={openReferencePDF}
      />
      <Menu
        open={!!menuAnchorEl}
        onClose={() => {
          setMenuAnchorEl(null)
          setSelectedMenuReference(null)
        }}
        anchorEl={menuAnchorEl}
      >
        <MenuItem
          onClick={handleResendInvitation}
          disabled={
            !validator.isEmail(
              application[`reference${selectedMenuReference}`]?.email ?? '',
            )
          }
        >
          Resend Invitation
        </MenuItem>
        <MenuItem onClick={handleReferenceURL}>Show Referee URL</MenuItem>
        <MenuItem onClick={() => setOpenEditReferee(true)}>
          Edit Referee
        </MenuItem>
        <MenuItem onClick={() => setOpenAddResponse(true)}>
          Add Response
        </MenuItem>
      </Menu>
      <BigModal
        open={!!openEditReferee || !!openAddResponse}
        onClose={() => {
          setMenuAnchorEl(null)
          setOpenEditReferee(false)
          setSelectedMenuReference(null)
          setOpenAddResponse(false)
        }}
      >
        <EditReferee
          existingReferee={application?.[`reference${selectedMenuReference}`]}
          selectedMenuReference={selectedMenuReference}
          applicationID={application._id}
          addManualResponse={openAddResponse}
          onClose={() => {
            setMenuAnchorEl(null)
            setOpenEditReferee(false)
            setSelectedMenuReference(null)
            getApplication()
            setOpenAddResponse(false)
          }}
        />
      </BigModal>
      <BigModal
        autoWidth
        open={!!referenceUrlToCopy}
        onClose={() => setReferenceUrlToCopy('')}
      >
        <Stack
          justifyContent="center"
          maxWidth={400}
          alignItems="center"
          gap={1}
        >
          <Typography variant="title2" fontSize="1.2rem">
            Use the following URL:
          </Typography>
          <Typography sx={{ wordBreak: 'break-word' }}>
            {referenceUrlToCopy}
          </Typography>
          <Button
            onClick={() => navigator.clipboard.writeText(referenceUrlToCopy)}
            startIcon={<ContentPasteIcon />}
            variant="contained"
          >
            Copy to Clipboard
          </Button>
        </Stack>
      </BigModal>
    </AccordComponent>
  )
}

export default References
